import { UserMinusIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanWithdrawReviewer } from "@components/ReportReview/hooks/useCanManageReview";
import { useReviewStatus } from "@components/ReportReview/hooks/useReviewStatus";
import { Reviewer } from "@components/ReportReview/reviewers";

export const WithdrawReviewerMenuItem: React.FC<{ reviewer: Reviewer }> = ({ reviewer }) => {
  const { setStatus } = useReviewStatus();
  const canWithdrawReviewer = useCanWithdrawReviewer(reviewer);

  return (
    <DropdownMenuItem
      variant="destructive"
      disabled={!canWithdrawReviewer}
      onClick={() =>
        void setStatus(ReportReviewerStatus.Withdrawn, { userId: reviewer.reviewer?.id }).catch(() => undefined)
      }
    >
      <UserMinusIcon />
      Withdraw Review Request
    </DropdownMenuItem>
  );
};
